import { createRouter, createWebHistory } from "vue-router";
import middlewarePipeline from "./middlewarePipeline";
import i18n from "../../i18n";
import adminRoutes from "./admin";
import teacherRoutes from "./teacher";
import authRoutes from "./auth";
import parentRoutes from "./parent";
import studentRoutes from "./student";
import generalRoutes from "./general";
import { authCookies } from "@/services/cookies";
import { updateAbility } from "@/abilities/ability";

const routes = [
  ...adminRoutes,
  ...teacherRoutes,
  ...authRoutes,
  ...parentRoutes,
  ...studentRoutes,
  ...generalRoutes,
];

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
});

const portalHome = (portal) => {
  if (portal === "parent") return { name: "ParentChildren" };
  if (portal === "student") return { name: "StudentHome" };
  return { name: "Dashboard" };
};

router.beforeEach((to, from, next) => {
  updateAbility(authCookies.getPermissions());

  const user = authCookies.getUser() || {};
  const authed = authCookies.hasSession();
  const portal = user.portal;

  if (
    authed &&
    portal === "parent" &&
    to.meta.portal !== "parent" &&
    to.name !== "Auth"
  ) {
    return next(portalHome("parent"));
  }

  if (
    authed &&
    portal === "student" &&
    to.meta.portal !== "student" &&
    to.name !== "Auth"
  ) {
    return next(portalHome("student"));
  }

  if (authed && portal && portal !== "parent" && to.meta.portal === "parent") {
    return next(portalHome(portal));
  }

  if (authed && portal && portal !== "student" && to.meta.portal === "student") {
    return next(portalHome(portal));
  }

  if (!to.meta.middleware) {
    return next();
  }

  const middleware = to.meta.middleware;

  const context = {
    to,
    from,
    next,
  };

  return middleware[0]({
    ...context,
    next: middlewarePipeline(context, middleware, 1),
  });
});

router.afterEach((to) => {
  if (to.meta.portal === "parent" && to.meta.titleKey) {
    document.title = `${i18n.global.t("parent_portal")} · ${i18n.global.t(
      to.meta.titleKey
    )}`;
    return;
  }

  if (to.meta.portal === "student" && to.meta.titleKey) {
    document.title = `${i18n.global.t("student_portal")} · ${i18n.global.t(
      to.meta.titleKey
    )}`;
    return;
  }

  const baseTitle = i18n.global.t("manage");

  if (to.meta.titleKey) {
    document.title = `${baseTitle} ${i18n.global.t(to.meta.titleKey)}`;
  }
});

export default router;
